import React from 'react'
import { Button } from '@shared/components/button'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import { useScreenSize } from '@shared/hooks/use-screen-size'

import DocsIcon from './icons/docs.svg'
import MarkIcon from './icons/mark.svg'
import PersonIcon from './icons/person.svg'

import styles from './style.module.scss'

interface Props {
	title?: string
	isVisibleConditions?: boolean
	loanParticipantRequirements?: string[]
	loanDocuments?: string[]
}

export const CreditConditions = ({
	title,
	isVisibleConditions,
	loanParticipantRequirements,
	loanDocuments,
}: Props) => {
	const { isDesktop } = useScreenSize()
	return (
		<div className='pt-l'>
			<h2>{title || 'Условия рассмотрения заявки'}</h2>
			{isVisibleConditions !== false && (
				<div className={styles.docsWrapper}>
					<div className={styles.docsList}>
						<div className={styles.docsIcon}>
							<PersonIcon />
						</div>
						<div className={styles.docsText}>
							<h3>Заёмщик</h3>
							<div className='mt-s'>
								{(
									loanParticipantRequirements || [
										'Гражданство РФ',
										'Любая кредитная история',
										'Любая форма дохода',
										'Возраст — от 21 до 65 лет',
									]
								).map((item) => (
									<div className={styles.docItem} key={item}>
										<div className={styles.docMarkIcon}>
											<MarkIcon />
										</div>
										<span>{item}</span>
									</div>
								))}
							</div>
						</div>
					</div>
					<div className={styles.docsList}>
						<div className={styles.docsIcon}>
							<DocsIcon />
						</div>
						<div className={styles.docsText}>
							<h3>Минимальный список документов</h3>
							<div className='mt-s'>
								{(
									loanDocuments || [
										'Паспорт — скан или фото всех страниц',
										'СНИЛС',
										'Номер телефона и почта',
									]
								).map((item) => (
									<div className={styles.docItem} key={item}>
										<div className={styles.docMarkIcon}>
											<MarkIcon />
										</div>
										<span>{item}</span>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			)}
			<div className={styles.stepsWrapper}>
				<div className={styles.stepsTitle}>
					<h3>Решение за полчаса</h3>
					{isDesktop && (
						<div className='mt-m'>
							<Button onClick={scrollToApplicationForm}>Оставить заявку</Button>
						</div>
					)}
				</div>
				<div className={styles.steps}>
					<div className={styles.step}>
						<div className={styles.stepNumber}>1</div>
						<div className={styles.stepTitle}>Оставьте заявку на заём</div>
					</div>
					<div className={styles.step}>
						<div className={styles.stepNumber}>2</div>
						<div className={styles.stepTitle}>Загрузите документы</div>
					</div>
					<div className={styles.step}>
						<div className={styles.stepNumber}>3</div>
						<div className={styles.stepTitle}>Узнайте решение за полчаса</div>
					</div>
				</div>
				{!isDesktop && (
					<div className='mt-l flex justify-center'>
						<Button onClick={scrollToApplicationForm}>Оставить заявку</Button>
					</div>
				)}
			</div>
		</div>
	)
}
